import React, { Component, type ErrorInfo, type ReactNode } from "react";
import { Alert, AlertTitle, Box } from "@mui/material";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

class RecordAudioErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("RecordAudio error:", error, errorInfo);
  }

  render(): React.ReactNode {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <Box sx={{ py: 1 }}>
          <Alert severity="error">
            <AlertTitle>Recording failed to load</AlertTitle>
            {error.message || "An unexpected error occurred in the recording component."}
          </Alert>
        </Box>
      );
    }

    return children;
  }
}

export default RecordAudioErrorBoundary;
